import PageShell from '../components/layout/PageShell';
import PageSeo from '../components/seo/PageSeo';
import HomeExperience from '../components/v2/HomeExperience';

export default function HomePage() {
  return (
    <PageShell>
      <PageSeo pageKey="home" />
      <HomeExperience />
    </PageShell>
  );
}
